import { ONE_SECOND } from '@/settings/constants'

/** @descriptio マーケティングサイト TOP */
export const MARKETING_TOP = 'https://cdpf.jp/docuvalue/'

/** @descriptio サービス紹介サイト */
export const SERVICE_INTRODUCE = 'https://cdpf.jp'

/** @descriptio SDSDirectユーザー登録 */
export const SDS_DIRECT_REGISTUSER = 'https://cdpf.jp/docuvalue/registuser/'

/** @description ログインガイドのリンク */
export const guideLink = {
  // マーケティングサイトのプライバシーポリシー
  PRAIVACY_POLICY: 'https://cdpf.jp/privacy/',
  // 利用規約
  SERVICE_TERMS: 'https://cdpf.jp/docuvalue/userpolicy',
  // サポートセンター（問い合わせページ）
  SUPPORT_CENTER: 'https://cdpf.jp/contact/',
  // 運営会社（NID ホームページ）
  MANAGEMENT_COMPANY: 'https://www.nagase.co.jp/nid',
}

/** @description DocuValue TOP ページのお知らせ */
export const NOTICE_PAGE = 'https://cdpf.jp/docuvalue/information/index.html'

/** @description ヘッダメニュー ChemValue遷移先ページ */
export const CHEM_VALUE_PAGE = process.env.VUE_APP_CHEM_VALUE_DESTINATION

/** @description ヘルプアイコンの遷移先 有料 */
export const MAIN_HELP_PAGE_PAID = `https://cdpf.jp/docuvaluehelp`

/** @description ヘルプアイコンの遷移先 無料 */
export const MAIN_HELP_PAGE_FREE = `https://cdpf.jp/docuvalue/manual/AA002.html`

/** @description 各ページのヘルプ */
export const helpFile = {
  /** @description フォルダ設定：フォルダ登録 / 更新の使い方 */
  HOW_TO_REGISTER_UPDATE_FOLDER: 'フォルダ登録・更新の使い方.pdf',
  /** @description 送信先マスタ：送信先マスタの使い方 */
  HOW_TO_USE_RECIPIENT_MASTER: '送信先マスタの使い方.pdf',
  /** @description 取引詳細：取引の受領方法 / 受領拒否方法 */
  HOW_TO_ACCEPT_REFUSE_TRANSACTION: '取引の受領方法・受領拒否方法.pdf',
  /** @description 企業情報：APIキー確認画面　APIキーの使い方 */
  HOW_TO_USE_API_KEY: 'APIキーの使い方.pdf',
  /** @description 送信先選択：送信したい取引先が表示されない場合 */
  IF_CLIENT_FOR_SEND_NOT_DISPLAYED: '送信先選択.pdf',
  /** @description 送信先選択：送信したい担当者名が表示されない場合 */
  IF_RESPONSE_FOR_SEND_PERSON_NOT_DISPLAYED: '送信先選択.pdf',
  /** @description 送信先選択：送信したいフォルダが表示されない場合 */
  IF_FOLDER_FOR_SEND_NOT_DISPLAYED: '送信先選択.pdf',
}

/** トークン更新の期限マイナス修正値 */
export const TOKEN_REFRESH_LEAD: number = 190 * ONE_SECOND
